// extracted by mini-css-extract-plugin
export default {"container":"booking_container__VJbkb"};